import {
  GatewayAvancement,
  GatewayDeclarationActivite,
} from "@conformite/gateway";
import { MaxWidthContent, TagConformite, Card } from "@endya-conformite/ui-kit";
import { ConformiteSocieteActions } from "@src/conformite/societeActions/ConformiteSocieteActions";
import { useOnce } from "@src/hooks/useOnce";
import styles from "../ConformiteDeclarationActivite.module.scss";
import {
  ConformiteDeclarationActiviteIobspForm,
  useDeclarationActiviteIobspForm,
} from "./ConformiteDeclarationActiviteIobspForm";

type ConformiteDeclarationActiviteIobspEditProps = {
  siren: string;
  declarationActivite: GatewayDeclarationActivite.DeclarationActiviteIobsp | null;
  isConforme: boolean;
  millesime: number;
  stopEditing: (
    value?: GatewayDeclarationActivite.DeclarationActiviteIobsp,
    avancement?: GatewayAvancement.AvancementSociete
  ) => void;
};

export function ConformiteDeclarationActiviteIobspEdit({
  siren,
  isConforme,
  declarationActivite,
  millesime,
  stopEditing,
}: ConformiteDeclarationActiviteIobspEditProps) {
  const { form, onSubmit } = useDeclarationActiviteIobspForm(
    siren,
    millesime,
    declarationActivite,
    stopEditing
  );

  useOnce(() => {
    if (declarationActivite !== null) {
      form.trigger().catch(console.error);
    }
  });

  return (
    <MaxWidthContent size="large" className={styles.contentEditable}>
      <Card className={styles.content}>
        <div className={styles.cardHeaderLeft}>
          <h3>Formulaire</h3>
          <TagConformite isConforme={isConforme} year={millesime} isEditing />
        </div>
        <ConformiteDeclarationActiviteIobspForm form={form} />
        <ConformiteSocieteActions
          onClick={() => {
            onSubmit(form.getValues()).catch(console.error);
          }}
          isLoading={false}
          stopEditing={() => stopEditing()}
        />
      </Card>
    </MaxWidthContent>
  );
}
